import type { InspectionState } from "../InspectionsLists.d";
import selectsLists, {
  COLOURS_STRING,
  ENGINE_COLOURS,
  ENGINE_TYPES,
  INSPECTION_PHASES_VALUES,
} from "@/assets/constants/selectsLists";

export const getFieldsToSearch = (
  tableType: InspectionState,
  isMobile?: boolean,
) => {
  const { engineTypes, inspectionPhases } = selectsLists;
  if (tableType === "active") {
    return [
      {
        name: "startDate",
        type: "date",
        data: null,
      },
      {
        name: "engineType",
        type: "select",
        data: isMobile ? ENGINE_TYPES : engineTypes,
      },
      {
        name: "snStand",
        type: "string",
        data: null,
      },
      {
        name: "esnEnter",
        type: "string",
        data: null,
      },
      {
        name: "colour",
        type: "select",
        data: isMobile ? ENGINE_COLOURS : COLOURS_STRING,
      },
      {
        name: "phase",
        type: "select",
        data: isMobile ? INSPECTION_PHASES_VALUES : inspectionPhases,
      },
    ];
  }
  return [
    {
      name: "startDate",
      type: "date",
      data: null,
    },
    {
      name: "endDate",
      type: "date",
      data: null,
    },
    {
      name: "engineType",
      type: "select",
      data: isMobile ? ENGINE_TYPES : engineTypes,
    },
    {
      name: "snStand",
      type: "string",
      data: null,
    },
    {
      name: "esnExit",
      type: "string",
      data: null,
    },
    {
      name: "colour",
      type: "select",
      data: isMobile ? ENGINE_COLOURS : COLOURS_STRING,
    },
  ];
};

export const getIsFiltered = (url: string) => {
  const filterParams = [
    "&createdAt=",
    "&endDate=",
    "&nsStand=",
    "&esnIn=",
    "&esnOut=",
    "&phaseId=",
    "&engineId=",
    "&colour=",
  ];
  return filterParams.some((filter) => url.includes(filter));
};
